<div class="well shadow-settings-well mb-20">
    <div class="form-group mb-10">
        <label class="col-xs-6 control-label">
            {{ "shadow_offset_x" | translate }}
        </label>
        <div class="col-xs-6">
            <sp-input-num
                suffixText="px"
                [min]="-200"
                [max]="200"
                [value]="offsetXValue()"
                (valueChange)="setOffsetX($event)"
            ></sp-input-num>
        </div>
    </div>

    <div class="form-group mb-10">
        <label class="col-xs-6 control-label">
            {{ "shadow_offset_y" | translate }}
        </label>
        <div class="col-xs-6">
            <sp-input-num
                suffixText="px"
                [min]="-200"
                [max]="200"
                [value]="offsetYValue()"
                (valueChange)="setOffsetY($event)"
            ></sp-input-num>
        </div>
    </div>

    <div class="form-group mb-10">
        <label class="col-xs-6 control-label">
            {{ "shadow_blur" | translate }}
        </label>
        <div class="col-xs-6">
            <sp-input-num
                suffixText="px"
                [min]="0"
                [max]="200"
                [value]="blurValue()"
                (valueChange)="setBlur($event)"
            ></sp-input-num>
        </div>
    </div>

    <div class="form-group mb-10">
        <label class="col-xs-6 control-label">
            {{ "shadow_spread" | translate }}
        </label>
        <div class="col-xs-6">
            <sp-input-num
                suffixText="px"
                [min]="-200"
                [max]="200"
                [value]="spreadValue()"
                (valueChange)="setSpread($event)"
            ></sp-input-num>
        </div>
    </div>

    <div class="form-group mb-0">
        <label class="col-xs-4 control-label">
            {{ "shadow_color" | translate }}
        </label>
        <div class="col-xs-8 text-right shadow-color-picker">
            <sp-input-num
                suffixText="%"
                [min]="0"
                [max]="100"
                [value]="colorAlphaValue()"
                (valueChange)="setColorAlpha($event)"
            ></sp-input-num>
            <sp-color-picker
                [color]="colorValue()"
                [hideGradient]="true"
                (colorChangeEvent)="setShadowColor($event)"
            ></sp-color-picker>
        </div>
    </div>
</div>
